import { reactive } from "vue";

export const Roles = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  DEALER_ADMIN: "DealerAdmin",
  DEALER_USER: "DealerUser",
  CUSTOMER_ADMIN: "CustomerAdmin",
  CUSTOMER_USER: "CustomerUser",
};

// UI dropdown vs için gerekiyorsa:
export const RoleList = [
  { name: "Super Admin", value: Roles.SUPER_ADMIN },
  { name: "Admin", value: Roles.ADMIN },
  { name: "Dealer Admin", value: Roles.DEALER_ADMIN },
  { name: "Dealer User", value: Roles.DEALER_USER },
  { name: "Customer Admin", value: Roles.CUSTOMER_ADMIN },
  { name: "Customer User", value: Roles.CUSTOMER_USER },
];

export const ApplicationStatusType = {
  Active: 1,
  Suspended: 2,
  Expired: 3,
  Disabled: 4
};

export const ApplicationStatusTypeList = [
  { name: "Active", value: ApplicationStatusType.Active },
  { name: "Suspended", value: ApplicationStatusType.Suspended },
  { name: "Expired", value: ApplicationStatusType.Expired },
  { name: "Disabled", value: ApplicationStatusType.Disabled },
];

export const ApplicationModeType = {
  CWMS: 1,
  CEMS: 2,
  AQ: 3,
  DataLogger: 4 ,
  Proses: 5,
  Mucilage: 6,
};

export const ApplicationModeTypeList = [
  { name: "CWMS", value: ApplicationModeType.CWMS },
  { name: "CEMS", value: ApplicationModeType.CEMS },
  { name: "AQ", value: ApplicationModeType.AQ },
  { name: "DataLogger", value: ApplicationModeType.DataLogger },
  { name: "Proses", value: ApplicationModeType.Proses },
  { name: "Mucilage", value: ApplicationModeType.Mucilage },
];

export const ProductType = [
  { name: "Yunus Data Toplama", value: 0 },
  { name: "EnviPRO", value: 1 },
  { name: "Transmitter", value: 2 },
  { name: "Aydogan Erp Entegration", value: 3 },
  { name: "Aydogan Cloud Backup", value: 4 },
  { name: "Aydogan Fuel Station", value: 5 },
];

export const LicenseType = [
  { name: "Perpetual", value: 0 },
  { name: "Trial", value: 1 },
  { name: "Subscription", value: 2 },
];

export const LicenseState = {
  Pending: 0,
  Active: 1,
  Expired: 2,
  Revoked: 3,
};

export const LicenseStateList = [
  { name: "Pending", value: LicenseState.Pending },
  { name: "Active", value: LicenseState.Active },
  { name: "Expired", value: LicenseState.Expired },
  { name: "Revoked", value: LicenseState.Revoked },
];

export const MaintenanceState = {
  Active: 1,
  Expired: 2,
};

export const MaintenanceStateList = [
  { name: "Active", value: MaintenanceState.Active },
  { name: "Expired", value: MaintenanceState.Expired },
];

export const NoteType = [
  { name: "Service", value: 0 },
  { name: "License", value: 1 },
  { name: "Update", value: 2 },
  { name: "Trace", value: 3 },
  { name: "Maintenance", value: 4 },
  { name: "Develop", value: 5 },
];

export const Operator = [
  { name: "=", },
  { name: ">", },
  { name: "<", },
  { name: ">=", },
  { name: "<=", },
  { name: "!=", },
];

export const SmsService = {
  NetGSM: 1,
  WPWifiNoktam: 2
};

export const SmsServiceList = [
  { name: "NetGSM", value: SmsService.NetGSM },
  { name: "WPWifiNoktam", value: SmsService.WPWifiNoktam },
];

export const EmailService = {
  Custom: 1,
  ReSend: 2,
};

export const EmailServiceList = [
  { name: "Custom", value: EmailService.Custom },
  { name: "ReSend", value: EmailService.ReSend },
];

export function GetName(type, value) {
  return type.find(x => x.value === value)?.name ?? null;
}

export const FlatPickrState = reactive({
  // Initial values
  dateDefault: null,
  dateCustom: null,
  dateFriendly: null,
  dateRange: null,
  timeStandalone: null,
  timeStandalone24: null,
  timeDateTime: null,
  timeDateTime24: null,
  inlineDefault: null,
  inlineTime: null,

  // Configuration, get more form https://chmln.github.io/flatpickr/options/
  configCustom: {
    altInput: true,
    altFormat: "d-m-Y",
    dateFormat: "Y-m-d",
  },
  configFriendly: { dateFormat: "F j, Y" },
  configRange: { mode: "range", minDate: "today" },
  configTimeStandalone: {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
  },
  configTimeStandalone24: {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
  },
  configDateTime: { enableTime: true },
  configDateTime24: { enableTime: true, time_24hr: true },
  configInlineDefault: { inline: true },
  configInlineTime: { inline: true, enableTime: true },
});
